import React, { useContext, useEffect, useState, useRef, useMemo } from 'react'
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Button, CircularProgress, Typography, IconButton, MenuItem, Divider, Menu, Switch } from '@mui/material';
import ApiService from '../../functions/apiService';
import moment from 'moment/moment';
import { useSelector, useDispatch } from 'react-redux'
import { setDashboard, setDashboardSelectedEmp, setDashboardShifts, setDashboardAbsentReasonAll, setDashboardEmployeeToSwap } from '../../store/dashboardReducer'
import AuthContext from '../../context/AuthContext';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { toast } from "react-toastify";
import WeeklyVolunteerPositionAssign from './WeeklyVolunteerPositionAssign';
import dayjs from "dayjs";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { MobileDatePicker } from '@mui/x-date-pickers';
import ButtonDatePickerNew from '../../components/DatePickers/ButtonDatePickerNew';
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Link } from "react-router-dom";

export default function WeeklyScheduleView() {
    const { permission, pages, pagesName, is_dn_deparment, user, v3Data } = useContext(AuthContext);
    let data = useSelector((state) => state.dashboardReducer.Data)
    let date = useSelector((state) => state.dashboardReducer.Date)
    let SelectedEmp = useSelector((state) => state.dashboardReducer.SelectedEmp)
    let Shifts = useSelector((state) => state.dashboardReducer.Shifts)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [searchParams, setSearchParams] = useSearchParams();
    const routeDate = searchParams.get('date');
    const [loading, setLoading] = useState(true);
    const [showDay, setShowDay] = useState(false);
    const [positionLoading, setPositionLoading] = useState(false);
    const [mode, setMode] = useState('');
    const [isNightShift, setIsNightShift] = useState(false);
    const [expandAll, setExpandAll] = useState(true);
    const [anyExpanded, setAnyExpanded] = useState(true);
    const [isScrolled, setIsScrolled] = useState(false);
    const [newData, setNewData] = useState([])
    const [requiredPositionCounts, setRequiredPositionCounts] = useState('')
    const [dayData, setDayData] = useState([])
    const [currentVehicleCounts, setCurrentVehicleCounts] = useState({})
    const [currentPositionCounts, setCurrentPositionCounts] = useState({})
    const [emptyOfficers, setEmptyOfficers] = useState([])
    const [emptyCounts, setEmptyCounts] = useState([])
    const [nightData, setNightData] = useState([])
    const [currentVehicleCountsNight, setCurrentVehicleCountsNight] = useState({})
    const [currentPositionCountsNight, setCurrentPositionCountsNight] = useState({})
    const [emptyOfficersNight, setEmptyOfficersNight] = useState([])
    const [emptyCountsNight, setEmptyCountsNight] = useState([])
    const [overTimeModal, setOverTimeModal] = useState(false)
    const [showToggleComponent, setShowToggleComponent] = useState(false);
    const [assignModal, setAssignModal] = useState(false)
    const [battalion, setBattalion] = useState(null);
    const [selectedSOValue, setselectedSOValue] = useState('');
    const [selectEmployee, setSelectEmployee] = useState([])
    const [shift, setShift] = useState('day');
    const [showAlert, setShowAlert] = useState(false)
    const [eligibleAlert, setEligibleAlert] = useState(false)
    const [positionData, setPositionData] = useState({})
    const [prevdates, setPrevDates] = useState([]);
    const [nextDates, setNextDates] = useState([]);
    const [assigndataModal, setAssignDataModal] = useState(false)
    const [revertStation, setRevertStation] = useState(false)
    const [revertData, setRevertData] = useState([])
    const [canPositionCount, setCanPositionCount] = useState(false)
    const [canRemoveOpenPos, setCanRemoveOpenPos] = useState(false)
    const [showAllOpenPos, setShowAllOpenPos] = useState(false)
    const allowedVars = v3Data;
    const [employees, setEmployees] = useState([])
    const [empSearch, setEmpSearch] = useState('')
    const [empLoading, setEmpLoading] = useState(false);
    const [selectedSearchEmp, setSelectedSearchEmp] = useState('');
    const [showDropdowns, setShowDropdowns] = useState(true);
    const [enableMultiSelect, setEnableMultiSelect] = useState(false);
    const [dropdownStyle, setDropdownStyle] = useState({
        opacity: 0,
        transform: 'translateY(-10px)',
        transition: 'opacity 0.3s ease, transform 0.3s ease',
        pointerEvents: 'none',
    });
    const [dropdownStyle2, setDropdownStyle2] = useState({
        opacity: 0,
        transform: 'translateY(-10px)',
        transition: 'opacity 0.3s ease, transform 0.3s ease',
        pointerEvents: 'none',
    });
    const [isReload, setIsReload] = useState(false)
    const [allShifts, setAllShifts] = useState('')
    const today = dayjs();
    const [anchorEl, setAnchorEl] = useState(null);
    const [showDots, setShowDots] = useState([]);
    const isIPad = useMediaQuery('(min-width: 660px) and (max-width: 1100px)');
    const [selectedDate, setSelectedDate] = useState(() => {
        const savedDate = localStorage.getItem('scheduleDate');
        if (savedDate) {
            return dayjs(savedDate);
        }
        return routeDate ? dayjs(routeDate) : dayjs();
    });

    const weekDays = useMemo(() => {
        const weekStart = dayjs(selectedDate).startOf("week");

        return Array.from({ length: 7 }, (_, i) => {
            const date = weekStart.add(i, "day");
            const dateStr = date.format('YYYY-MM-DD');
            // const hasOvertime = calendarData?.overtime?.some(
            //     overtime => overtime.shiftDate === dateStr && overtime.count > 0
            // );
            const dotData = showDots?.find(
                (item) => item.date === dateStr
            );

            return {
                day: date.format("ddd").toUpperCase(),
                date: date.date().toString(),
                active: date.isSame(today, "day"),
                highlighted: date.isSame(selectedDate, "day"),
                fullDate: date,
                // hasOvertime: hasOvertime || false, 
                showRedDot: (dotData?.openPositionCount ?? 0) > 0,
                showYellowDot: (dotData?.requestedCount ?? 0) > 0,
                group: dotData?.group || "",
                color: dotData?.color || "",
            };
        });
    }, [selectedDate, showDots]);

    const formattedRange = useMemo(() => {
        if (weekDays.length > 0) {
            return weekDays[0].fullDate.format("MMM D") + " - " + weekDays[6].fullDate.format("MMM D, YYYY");
        }
        return "";
    }, [weekDays]);

    const ChangeDateArrow = (direction) => {
        const newDate = selectedDate.add(direction * 7, "day");
        const formattedDate = newDate.format('YYYY-MM-DD');
        setSelectedDate(newDate);
        localStorage.setItem('scheduleDate', formattedDate);
        loadData(newDate.format('DD-MM-YYYY'));
        setSearchParams({ date: newDate.format('YYYY-MM-DD') });
        setIsNightShift(false);
        // getWeekCalendar(newDate);
        getWeeklySchedule(newData)
    };

    const open = Boolean(anchorEl);
    const [filterAnchorEl, setFilterAnchorEl] = useState(null);
    const filterMenuOpen = Boolean(filterAnchorEl);
    const [isDaysVisible, setIsDaysVisible] = useState(false);
    const [isPositionsVisible, setIsPositionsVisible] = useState(false);
    const handleFilterClick = (event) => setFilterAnchorEl(event.currentTarget);
    const handleFilterClose = () => setFilterAnchorEl(null);
    const [anchorElOptions, setAnchorElOptions] = React.useState(null);
    const handleOpenOptions = (event) => setAnchorElOptions(event.currentTarget);
    const handleCloseOptions = () => setAnchorElOptions(null);
    const [currentDate, setCurrentDate] = useState(dayjs());

    useEffect(() => {
        if (selectedDate) {
            const formattedDate = selectedDate.format('YYYY-MM-DD');
            localStorage.setItem('scheduleDate', formattedDate);
        }
        if (selectedDate) {
            getWeeklySchedule(selectedDate)
        }
    }, [selectedDate]);

    useEffect(() => {
        if (Object.keys(allowedVars).includes('V3_AUTO_SHOW_DAY_STAFF')) {
            setShowDay(true)
            setIsDaysVisible(true)
        }
    }, [allowedVars.V3_AUTO_SHOW_DAY_STAFF])

    const handlePrevDay = () => {
        setCurrentDate(prev => prev.subtract(1, "day"));
    };

    const handleNextDay = () => {
        setCurrentDate(prev => prev.add(1, "day"));
    };

    const getWeeklySchedule = async (startDate) => {
        try {
            const response = await ApiService.post(
                '/weeklySchedule',
                {
                    date: startDate.format('YYYY-MM-DD')
                },
                {},
                'weeklySchedule'
            )
            if (response?.success) {
                setShowDots(response?.data)
            }
        } catch (error) {
            console.error('Error fetching weekly schedule:', error);
        }
    };

    const [mode2, setMode2] = useState(() => {
        const storedMode = localStorage.getItem("mode");
        if (storedMode && storedMode !== '') {
            return storedMode;
        }
        else if (pages.includes("V3_DEFAULT_TOGGLE_VIEW")) {
            return "24";
        }
        else {
            return "day";
        }
    });

    useEffect(() => {
        if (is_dn_deparment === 'DN_TOGGLE') {
            localStorage.setItem("mode", mode2);
        }
    }, [mode2]);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        setIsScrolled(scrollTop > 300);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleExpandChange = (isExpanded) => {
        if (isExpanded) {
            setAnyExpanded(true);
        }
        else {
            setAnyExpanded(false);
        }
    };

    const toggleAllCollapses = () => {
        setExpandAll(prev => !prev);
        if (!expandAll) {
            setAnyExpanded(true);
        }
        else {
            setAnyExpanded(false);
        }
    };

    useEffect(() => {
        if (selectedSearchEmp != '') {
            if (routeDate === null) {
                loadData();
            } else {
                loadData(moment(routeDate, 'YYYY-MM-DD').format('DD-MM-YYYY'))
            }
        }
    }, [selectedSearchEmp])

    useEffect(() => {
        if (routeDate === null) {
            loadData();
        } else {
            loadData(moment(routeDate, 'YYYY-MM-DD').format('DD-MM-YYYY'))
        }
    }, [allowedVars && Object.keys(allowedVars).includes('V3_BATTALION_FEATURE')])

    const loadData = (dateInput = '', load = true) => {
        // if (battalion != null) {
        if (load == true) {
            setLoading(true)
        }
        let Query = dateInput != '' ? '?date=' + dateInput : ''
        let Query2 = dateInput != '' ? '&Battalion_Code=' : '?Battalion_Code='
        ApiService.get('/todayShift' + Query + Query2 + selectedSOValue + '&Emp_Code=' + selectedSearchEmp, {}, 'todayShift')
            .then(({ data }) => {
                dispatch(setDashboard(data));
                dispatch(setDashboardSelectedEmp([]))
                setLoading(false)
            }).catch((error) => {
                setLoading(false)
                toast.error("Error")
            })
        // }
    }

    const loadDropDowns = () => {
        ApiService.get('/absentCodes?condition=all', {}, 'absentCodes').then(({ data }) => {
            dispatch(setDashboardAbsentReasonAll(data.data));
        }).catch(() => {
            toast.error("Error")
        })
        ApiService.get('/employeeToSwap', {}, 'employeeToSwap').then(({ data }) => {
            dispatch(setDashboardEmployeeToSwap(data));
        }).catch(() => {
            toast.error("Error")
        })
    }

    const shiftTypes = () => {
        ApiService.get('/shiftTypes', {}, 'shiftTypes').then(({ data }) => {
            dispatch(setDashboardShifts(data.data));
            setAllShifts(data?.data)
        }).catch(() => {
            toast.error("Error")
        })
    }

    useEffect(() => {
        shiftTypes()
    }, [])

    const loadEmployees = () => {
        setEmpLoading(true)
        ApiService.get('/searchEmployees?search=' + empSearch)
            .then(({ data }) => {
                var tempArr = []
                data.data.map((emp) => {
                    var obj = {
                        label: `${emp.employee_assignment.EA_Rank} ${emp.fullName}`,
                        value: emp.Emp_Code
                    }
                    tempArr.push(obj)
                })
                setEmployees(tempArr)
                setEmpLoading(false)
            })
            .catch((e) => {
                setEmpLoading(false);
            })
    }

    useEffect(() => {
        if (empSearch.length >= 3) {
            loadEmployees()
        }
        else {
            setEmployees([])
        }
    }, [empSearch])

    let getToday = () => {
        const today = dayjs();
        const todayFormatted = today.format('YYYY-MM-DD');
        setSelectedDate(today);
        localStorage.setItem('scheduleDate', todayFormatted);
        loadData(moment().format('DD-MM-YYYY'));
        setSearchParams({ date: moment().format('YYYY-MM-DD') })
    }

    let groupName = Object.keys(pagesName).includes("GROUP_HEADER_TEXT")
        ? pagesName.GROUP_HEADER_TEXT
        : "Group";

    useEffect(() => {
        if (routeDate) {
            loadData(moment(routeDate, 'YYYY-MM-DD').format('DD-MM-YYYY'), false)
        }
    }, [isNightShift])

    useEffect(() => {
        if (data) {
            var tempPositionObjNight = {}
            var tempVehicleObjNight = {}
            var emptyOfficersObjNight = {}
            var tempNightData = JSON.parse(JSON.stringify(data));

            tempNightData.stations = tempNightData.stations.map(station => ({
                ...station,
                employees: is_dn_deparment === 'DN_TOGGLE'
                    ? station.employees
                        .filter(emp => emp.inNIGHTShift)
                        .map((emp, i, filteredEmployees) => {
                            if (tempPositionObjNight[emp?.Position_Code] == undefined || tempPositionObjNight[emp?.Position_Code] == null) {
                                if (emp?.customShiftsArrayNight?.length > 0) {
                                    if (emp?.customShiftsArrayNight?.find(a => a.nightStatus != 'F' && a.nightStatus != '')) {
                                        tempPositionObjNight[emp?.Vehicle_Code] = 0;
                                    }
                                }
                                else {
                                    if (emp?.nightStatus != 'F' && emp?.nightStatus != '') {
                                        tempPositionObjNight[emp?.Position_Code] = 0
                                    }
                                    else {
                                        tempPositionObjNight[emp?.Position_Code] = 1
                                    }
                                }
                            }
                            else {
                                if (emp?.customShiftsArrayNight?.length > 0) {
                                    if (emp?.customShiftsArrayNight?.find(a => a.nightStatus == 'F' || a?.nightStatus == '')) {
                                        tempPositionObjNight[emp?.Position_Code] = tempPositionObjNight[emp?.Position_Code] + 1
                                    }
                                }
                                else if (emp?.nightStatus == 'F' || emp?.nightStatus == '') {
                                    tempPositionObjNight[emp?.Position_Code] = tempPositionObjNight[emp?.Position_Code] + 1
                                }
                            }

                            // for vehicle code
                            if (tempVehicleObjNight[emp?.Vehicle_Code] == undefined || tempVehicleObjNight[emp?.Vehicle_Code] == null) {
                                if (emp?.customShiftsArrayNight?.length > 0) {
                                    if (emp?.customShiftsArrayNight?.find(a => a.nightStatus != 'F' && a.nightStatus != '')) {
                                        tempVehicleObjNight[emp?.Vehicle_Code] = 0;
                                        if (emp?.Position_Code.includes('COE') || emp?.Position_Code.includes('COT') || emp?.Position_Code.includes('COR')) {
                                            const engine = `${emp?.PositionName.split(' ')[0]} ${emp?.PositionName.split(' ')[1]}`;
                                            emptyOfficersObjNight[emp?.Position_Code] = engine;
                                        }
                                    } else {
                                        tempVehicleObjNight[emp?.Vehicle_Code] = 1;
                                    }
                                } else {
                                    if (emp?.nightStatus != 'F' && emp?.nightStatus != '') {
                                        tempVehicleObjNight[emp?.Vehicle_Code] = 0;
                                        if (emp?.Position_Code.includes('COE') || emp?.Position_Code.includes('COT') || emp?.Position_Code.includes('COR')) {
                                            const engine = `${emp?.PositionName.split(' ')[0]} ${emp?.PositionName.split(' ')[1]}`;
                                            emptyOfficersObjNight[emp?.Position_Code] = engine;
                                        }
                                    } else {
                                        tempVehicleObjNight[emp?.Vehicle_Code] = 1;
                                    }
                                }
                            }
                            else {
                                if (emp?.customShiftsArrayNight?.length > 0) {
                                    if (emp?.customShiftsArrayNight?.find(a => a.nightStatus == 'F' || a?.nightStatus == '')) {
                                        tempVehicleObjNight[emp?.Vehicle_Code] = tempVehicleObjNight[emp?.Vehicle_Code] + 1;
                                    }
                                } else if (emp?.nightStatus == 'F' || emp?.nightStatus == '') {
                                    tempVehicleObjNight[emp?.Vehicle_Code] = tempVehicleObjNight[emp?.Vehicle_Code] + 1;
                                }
                            }

                            if (i !== 0 && emp.Vehicle_Code !== filteredEmployees[i - 1]?.Vehicle_Code) {
                                return { ...emp, addSeparator: true };
                            }

                            return emp;
                        })
                    : station.employees.filter(emp => emp.inNIGHTShift)
            }));

            tempNightData.dayEmployee = tempNightData.dayEmployee.map(station => ({
                ...station,
                employees: station.employees.filter(employee => employee.inNIGHTShift)
            }));

            setNightData(tempNightData)
            setCurrentPositionCountsNight(tempPositionObjNight)
            setCurrentVehicleCountsNight(tempVehicleObjNight)
            getEmptyCountsNight(tempPositionObjNight, emptyOfficersObjNight)

            var tempVehicleObjDay = {}
            var tempPositionObjDay = {}
            var emptyOfficersObjDay = {}
            var tempDayData = JSON.parse(JSON.stringify(data));

            tempDayData.stations = tempDayData.stations.map(station => ({
                ...station,
                employees: is_dn_deparment === 'DN_TOGGLE'
                    ? station.employees
                        .filter(emp => emp.inDayShift)
                        .map((emp, i, filteredEmployees) => {
                            if (tempPositionObjDay[emp?.Position_Code] == undefined || tempPositionObjDay[emp?.Position_Code] == null) {
                                if (emp?.customShiftsArrayDay?.length > 0) {
                                    if (emp?.customShiftsArrayDay?.find(a => a.dayStatus != 'F' && a.dayStatus != '')) {
                                        tempPositionObjDay[emp?.Position_Code] = 0
                                    }
                                    else {
                                        tempPositionObjDay[emp?.Position_Code] = 1
                                    }
                                }
                                else {
                                    if (emp?.dayStatus != 'F' && emp?.dayStatus != '') {
                                        tempPositionObjDay[emp?.Position_Code] = 0
                                    }
                                    else {
                                        tempPositionObjDay[emp?.Position_Code] = 1
                                    }
                                }
                            }
                            else {
                                if (emp?.customShiftsArrayDay?.length > 0) {
                                    if (emp?.customShiftsArrayDay?.find(a => a.dayStatus == 'F' || a?.dayStatus == '')) {
                                        tempPositionObjDay[emp?.Position_Code] = tempPositionObjDay[emp?.Position_Code] + 1
                                    }
                                }
                                else if (emp?.dayStatus == 'F' || emp?.dayStatus == '') {
                                    tempPositionObjDay[emp?.Position_Code] = tempPositionObjDay[emp?.Position_Code] + 1
                                }
                            }

                            //for vehicle code
                            if (tempVehicleObjDay[emp?.Vehicle_Code] == undefined || tempVehicleObjDay[emp?.Vehicle_Code] == null) {
                                if (emp?.customShiftsArrayDay?.length > 0) {
                                    if (emp?.customShiftsArrayDay?.find(a => a.dayStatus != 'F' && a.dayStatus != '')) {
                                        tempVehicleObjDay[emp?.Vehicle_Code] = 0;
                                        if (emp?.Position_Code.includes('COE') || emp?.Position_Code.includes('COT') || emp?.Position_Code.includes('COR')) {
                                            const engine = `${emp?.PositionName.split(' ')[0]} ${emp?.PositionName.split(' ')[1]}`;
                                            emptyOfficersObjDay[emp?.Position_Code] = engine;
                                        }
                                    } else {
                                        tempVehicleObjDay[emp?.Vehicle_Code] = 1;
                                    }
                                } else {
                                    if (emp?.dayStatus != 'F' && emp?.dayStatus != '') {
                                        tempVehicleObjDay[emp?.Vehicle_Code] = 0;
                                        if (emp?.Position_Code.includes('COE') || emp?.Position_Code.includes('COT') || emp?.Position_Code.includes('COR')) {
                                            const engine = `${emp?.PositionName.split(' ')[0]} ${emp?.PositionName.split(' ')[1]}`;
                                            emptyOfficersObjDay[emp?.Position_Code] = engine;
                                        }
                                    } else {
                                        tempVehicleObjDay[emp?.Vehicle_Code] = 1;
                                    }
                                }
                            }
                            else {
                                if (emp?.customShiftsArrayDay?.length > 0) {
                                    if (emp?.customShiftsArrayDay?.find(a => a.dayStatus == 'F' || a?.dayStatus == '')) {
                                        tempVehicleObjDay[emp?.Vehicle_Code] = tempVehicleObjDay[emp?.Vehicle_Code] + 1;
                                    }
                                } else if (emp?.dayStatus == 'F' || emp?.dayStatus == '') {
                                    tempVehicleObjDay[emp?.Vehicle_Code] = tempVehicleObjDay[emp?.Vehicle_Code] + 1;
                                }
                            }

                            if (i !== 0 && emp.Vehicle_Code !== filteredEmployees[i - 1]?.Vehicle_Code) {
                                return { ...emp, addSeparator: true };
                            }
                            return emp;
                        })
                    : station.employees.filter(emp => emp.inDayShift)
            }));

            tempDayData.dayEmployee = tempDayData.dayEmployee.map(station => ({
                ...station,
                employees: station?.employees?.filter(employee => employee.inDayShift)
            }));

            setDayData(tempDayData)
            setCurrentPositionCounts(tempPositionObjDay)
            setCurrentVehicleCounts(tempVehicleObjDay)
            getEmptyCountsDay(tempPositionObjDay, emptyOfficersObjDay)
            if (!showAllOpenPos) {
                setCanRemoveOpenPos(!canRemoveOpenPos)
            }
        }
    }, [data, mode2, showAllOpenPos, showDropdowns])

    const getEmptyCountsDay = (currObj, emptyObj) => {
        var tempArr = []
        var tempEmptyObj = emptyObj
        Object.keys(currObj).length > 0 && Object.keys(requiredPositionCounts).length > 0 && Object.keys(requiredPositionCounts).map((key, i) => {
            if (currObj[key] == undefined) {
                let obj = {
                    id: i,
                    position: key,
                    min: requiredPositionCounts[key].min,
                    max: requiredPositionCounts[key].max,
                    positionName: requiredPositionCounts[key].position
                }
                tempArr.push(obj)
                if (key.includes('COE') || key.includes('COT') || key.includes('COR')) {
                    const engine = `${obj?.positionName.split(' ')[0]} ${obj?.positionName.split(' ')[1]}`;
                    tempEmptyObj[key] = engine;
                }
            }
        })
        setEmptyCounts(tempArr)
        setEmptyOfficers(tempEmptyObj)
    }

    const getEmptyCountsNight = (currObj, emptyObj) => {
        var tempArr = []
        var tempEmptyObj = emptyObj
        Object.keys(currObj).length > 0 && Object.keys(requiredPositionCounts).length > 0 && Object.keys(requiredPositionCounts).map((key, i) => {
            if (currObj[key] == undefined) {
                let obj = {
                    id: i,
                    position: key,
                    min: requiredPositionCounts[key].min,
                    max: requiredPositionCounts[key].max,
                    positionName: requiredPositionCounts[key].position
                }
                tempArr.push(obj)
                if (key.includes('COE') || key.includes('COT') || key.includes('COR')) {
                    const engine = `${obj?.positionName.split(' ')[0]} ${obj?.positionName.split(' ')[1]}`;
                    tempEmptyObj[key] = engine;
                }
            }
        })
        setEmptyCountsNight(tempArr)
        setEmptyOfficersNight(tempEmptyObj)
    }

    useEffect(() => {
        if (allowedVars && Object.keys(allowedVars).includes('V3_AUTO_HIDE_OPENS_IF_MIN_SATISFIED')) {
            if (currentPositionCounts && requiredPositionCounts) {
                var tempOpenDay = []
                Object.keys(currentPositionCounts).map((item) => {
                    var isOpen = dayData.stations.flatMap(station => station.employees).filter(emp => emp.Position_Code == item && ((emp.absentReason != '' && emp.absentReason != null && emp.dayStatus != 'F') || (emp.customShiftsArrayDay.length > 0 && emp.customShiftsArrayDay.filter(s => s.dayStatus != 'F').length > 0))).map(emp => emp.Emp_Code)
                    if ((parseInt(currentPositionCounts[item]) >= parseInt(requiredPositionCounts[item]?.max)) && isOpen.length > 0) {
                        tempOpenDay = [...tempOpenDay, ...isOpen]
                    }
                })
                const updatedStationsDay = dayData?.stations?.map(station => ({
                    ...station,
                    employees: station.employees.filter(emp => !tempOpenDay.includes(emp.Emp_Code))
                }));
                setDayData({ ...dayData, stations: updatedStationsDay });

                var tempOpenNight = []
                Object.keys(currentPositionCountsNight).map((item) => {
                    var isOpen = nightData.stations.flatMap(station => station.employees).filter(emp => emp.Position_Code == item && ((emp.absentReasonNight != '' && emp.absentReasonNight != null && emp.nightStatus != 'F') || (emp.customShiftsArrayNight.length > 0 && emp.customShiftsArrayNight.filter(s => s.nightStatus != 'F').length > 0))).map(emp => emp.Emp_Code)
                    if ((parseInt(currentPositionCountsNight[item]) >= parseInt(requiredPositionCounts[item]?.max)) && isOpen.length > 0) {
                        tempOpenNight = [...tempOpenNight, ...isOpen]
                    }
                })
                const updatedStationsNight = nightData?.stations?.map(station => ({
                    ...station,
                    employees: station.employees.filter(emp => !tempOpenNight.includes(emp.Emp_Code))
                }));
                setNightData({ ...nightData, stations: updatedStationsNight });
            }
        }
    }, [canRemoveOpenPos])

    useEffect(() => {
        if (mode2 === 'night') {
            setIsNightShift(true);
        }
        else {
            setIsNightShift(false);
        }
    }, [mode2])

    useEffect(() => {
        if (data?.date !== undefined) {
            ApiService.get(`/autoPopulateLongevityShifts?date=${data.date}`)
                .then((data) => {
                    if (data?.data?.count > 0) {
                        if (routeDate === null) {
                            loadData('', false);
                        }
                        else {
                            loadData(moment(routeDate, 'YYYY-MM-DD').format('DD-MM-YYYY'), false)
                        }
                    }
                })
                .catch(({ error }) => {
                    toast.error("Error")
                });
        }
    }, [data?.date])

    useEffect(() => {
        if (showDropdowns) {
            setDropdownStyle({
                opacity: 1,
                transform: 'translateY(0)',
                transition: 'opacity 1s ease, transform 0.5s ease',
                pointerEvents: 'auto',
            });
        } else {
            setDropdownStyle({
                opacity: 0,
                transform: 'translateY(-30px)',
                transition: 'opacity 1s ease, transform 0.5s ease',
                pointerEvents: 'none',
            });
        }
    }, [showDropdowns]);

    useEffect(() => {
        if (selectedSOValue != '') {
            if (routeDate === null) {
                loadData();
            } else {
                loadData(moment(routeDate, 'YYYY-MM-DD').format('DD-MM-YYYY'))
            }
        }
    }, [selectedSOValue])

    useEffect(() => {
        if (routeDate) {
            const routeDateObj = dayjs(routeDate);
            setSelectedDate(routeDateObj);
            // getWeekCalendar(routeDateObj);
            getWeeklySchedule(routeDate);
        }
    }, [routeDate]);

    let changeDate = (date) => {
        const formatted = moment(date).format("MM/DD/YYYY");
        const dayjsDate = dayjs(formatted);
        setSelectedDate(dayjsDate);
        loadData(moment(date).format('DD-MM-YYYY'));
        setSearchParams({ date: moment(date).format('YYYY-MM-DD') });
        setIsNightShift(false);
    }

    const changeDateCalendor = (dateItem) => {
        setSelectedDate(dateItem.fullDate);
        const formattedDate = dateItem.fullDate.format('YYYY-MM-DD');
        localStorage.setItem('scheduleDate', formattedDate);
        loadData(dateItem.fullDate.format('DD-MM-YYYY'));
        setSearchParams({ date: dateItem.fullDate.format('YYYY-MM-DD') });
        setIsNightShift(false);
    }

    const handleStartDate = () => {
        const arr = weekDays?.map(item => Number(item.date));
    }

    useEffect(() => {
        handleStartDate()
    }, [])

    return (
        <>
            {loading && (
                <Box className="w-100 h-100 d-flex justify-content-center align-items-center">
                    <CircularProgress />
                </Box>
            )}
            {!loading && data && mode == '' && (
                <Grid container spacing={2} columns={{ xs: 8, sm: 8, md: 12 }}>
                    <Grid item xs={12} lg={12} md={12}>
                        <Paper elevation={0} className=' shadow '
                            style={{
                                paddingTop: "20px",
                                marginTop: "1rem",
                                backgroundColor: isNightShift ? 'rgba(255, 255, 255, 0.6)' : '#fff',
                                maxWidth: '93vw',
                                overflow: 'auto',
                                msOverflowStyle: 'none',
                                scrollbarWidth: 'none',
                            }}>
                            <div className='schedule-container'>

                                {!isMobile && (
                                    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", pl: "10px", fontFamily: 'Karla', marginRight: '30px' }}>
                                        <Grid
                                            container
                                            alignItems="center"
                                            justifyContent="space-between"
                                            sx={{ px: 1, py: 0 }}
                                        >
                                            {/* Schedule Title */}
                                            <Grid item>
                                                <Typography
                                                    variant="h5"
                                                    sx={{
                                                        fontWeight: 600,
                                                        fontSize: { xs: '1.25rem', sm: '1.5rem' },
                                                        fontFamily: 'Karla'
                                                    }}
                                                >
                                                    <Link to="/firehouse/schedule" style={{ color: "black" }}>
                                                        <ArrowBackIosIcon />
                                                    </Link>
                                                    Weekly Schedule View
                                                </Typography>
                                            </Grid>

                                            {/* Expand / Collapse Button */}
                                            <Grid item>
                                                <Button
                                                    onClick={toggleAllCollapses}
                                                    variant="outlined"
                                                    startIcon={
                                                        <Box
                                                            component="img"
                                                            src={anyExpanded ? '/images/collapse.svg' : '/images/expand.svg'}
                                                            alt="Icon"
                                                            sx={{ width: '16px', height: '16px' }}
                                                        />
                                                    }
                                                    sx={{
                                                        fontSize: { xs: '11px', sm: '12px' },
                                                        padding: { xs: '4px 10px', sm: '5px 10px' },
                                                        textTransform: 'none',
                                                        fontFamily: 'karla',
                                                        borderRadius: '8px',
                                                        borderColor: '#E0E0E0',
                                                        color: '#000',
                                                        '&:hover': {
                                                            borderColor: '#BF1D2D',
                                                            backgroundColor: 'rgba(191, 29, 45, 0.04)'
                                                        }
                                                    }}
                                                >
                                                    {anyExpanded ? "Click to Collapse" : "Click to Expand"}
                                                </Button>
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={2} alignItems="center" sx={{ mt: 1, px: 1, py: 0 }}>
                                            {/* Go to Today Button */}
                                            <Grid item xs="auto">
                                                <Button
                                                    onClick={getToday}
                                                    variant="contained"
                                                    sx={{
                                                        backgroundColor: 'white',
                                                        color: '#000',
                                                        fontWeight: 500,
                                                        textTransform: 'none',
                                                        borderRadius: '8px',
                                                        marginBottom: '10px',
                                                        borderColor: "#E0E0E0",
                                                        fontFamily: 'karla',
                                                        fontSize: { xs: '12px', sm: '14px' },
                                                        padding: { xs: '4px 12px', sm: '5px 16px' },
                                                        '&:hover': {
                                                            borderColor: '#BF1D2D',
                                                            backgroundColor: 'rgba(191, 29, 45, 0.04)'
                                                        }
                                                    }}
                                                >
                                                    Go to Today
                                                </Button>
                                            </Grid>

                                            <Grid
                                                alignItems="center"
                                                sx={{ mt: 1, ml: 1 }}
                                            >
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "3px",
                                                    }}
                                                >
                                                    {/* Previous Arrow */}
                                                    <IconButton
                                                        onClick={() => ChangeDateArrow(-1)}

                                                    >
                                                        <ArrowBackIosNewIcon fontSize="small" />
                                                    </IconButton>

                                                    {/* Date Range Display */}
                                                    <Box

                                                    >
                                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                            <ButtonDatePickerNew
                                                                label={formattedRange}

                                                                value={data.date ? moment(data.date).toDate() : new Date()}
                                                                onChange={(e) => changeDate(e)}
                                                            />
                                                        </LocalizationProvider>

                                                    </Box>

                                                    {/* Next Arrow */}
                                                    <IconButton
                                                        onClick={() => ChangeDateArrow(1)}
                                                    // sx={{
                                                    //     border: "1px solid #E0E0E0",
                                                    //     borderRadius: "8px",
                                                    //     p: { xs: "4px", sm: "6px" },
                                                    //     color: "#374151",
                                                    //     "&:hover": { backgroundColor: "#F9FAFB" },
                                                    // }}
                                                    >
                                                        <ArrowForwardIosIcon fontSize="small" />
                                                    </IconButton>
                                                </Box>
                                            </Grid>

                                            {/* Week Days */}
                                            <Grid item xs={12} sm="auto" md="auto" sx={{ pt: '8px !important' }}  >
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        gap: 1,
                                                        justifyContent: { xs: "center", sm: "flex-end" },
                                                        flexWrap: "wrap"
                                                    }}
                                                >
                                                    {weekDays.map((item, index) => (

                                                        <Box
                                                            key={index}
                                                            sx={{
                                                                width: { xs: "50px", sm: "60px" },
                                                                textAlign: "center",
                                                                py: 0.4, // ⬅️ reduced height
                                                                px: 1.5,
                                                                borderRadius: "8px",
                                                                bgcolor: item.highlighted ? "#BF1D2D" : "transparent",
                                                                border: item.active
                                                                    ? "1px solid #BF1D2D"
                                                                    : "1px solid #E0E0E0",
                                                                cursor: "pointer",
                                                                position: "relative",
                                                                transition: "all 0.2s ease",
                                                                "&:hover": {
                                                                    borderColor: "#BF1D2D",
                                                                    backgroundColor: item.highlighted
                                                                        ? "#9f1c24"
                                                                        : "rgba(191, 29, 45, 0.04)"
                                                                }
                                                            }}
                                                            onClick={() => changeDateCalendor(item)}
                                                        >
                                                            {/* {item.hasOvertime && (
                                                                    <Box
                                                                        sx={{
                                                                            position: "absolute",
                                                                            bottom: "-3px",
                                                                            right: "43%",
                                                                            width: "8px",
                                                                            height: "8px",
                                                                            borderRadius: "50%",
                                                                            backgroundColor: "#BF1D2D",
                                                                           border: "1px solid #fff",
                                                                            zIndex: 1
                                                                        }}
                                                                    />
                                                                )} */}
                                                            <Box
                                                                sx={{
                                                                    position: "absolute",
                                                                    bottom: "-4px",
                                                                    left: "50%",
                                                                    transform: "translateX(-50%)",
                                                                    display: "flex",
                                                                    gap: "4px",
                                                                    zIndex: 2,
                                                                }}
                                                            >
                                                                {/* 🔴 Red Dot → openPositionCount > 0 */}
                                                                {item.showRedDot && (
                                                                    <Box
                                                                        sx={{
                                                                            width: "7px",
                                                                            height: "7px",
                                                                            borderRadius: "50%",
                                                                            backgroundColor: "#BF1D2D",
                                                                            border: "1px solid #fff",
                                                                        }}
                                                                    />
                                                                )}

                                                                {/* 🟡 Yellow Dot → requestedCount > 0 */}
                                                                {item.showYellowDot && (
                                                                    <Box
                                                                        sx={{
                                                                            width: "7px",
                                                                            height: "7px",
                                                                            borderRadius: "50%",
                                                                            backgroundColor: "#FACC15",
                                                                            border: "1px solid #fff",
                                                                        }}
                                                                    />
                                                                )}
                                                            </Box>

                                                            <Typography
                                                                variant="caption"
                                                                sx={{
                                                                    display: "block",
                                                                    fontSize: "11px",
                                                                    fontWeight: 600,
                                                                    color: item.highlighted ? "#fff" : "#666",
                                                                    mb: 0.5
                                                                }}
                                                            >
                                                                {item.day}
                                                            </Typography>
                                                            {item.group && (
                                                                <Typography
                                                                    style={{ color: item?.color ? item.color.toLowerCase() : "#000" }}
                                                                    sx={{
                                                                        fontSize: "10px",
                                                                        fontWeight: 600,
                                                                        lineHeight: 1,
                                                                        mb: 0.3,
                                                                        // color: CSS.supports("color", item.color?.toLowerCase())
                                                                        //     ? item.color.toLowerCase()
                                                                        //     : "#000",
                                                                    }}
                                                                >
                                                                    {item.group}
                                                                </Typography>
                                                            )}
                                                            <Typography
                                                                variant="h6"
                                                                sx={{
                                                                    fontSize: "16px", // smaller
                                                                    fontWeight: 600,
                                                                    color: item.highlighted ? "#fff" : "#000"
                                                                }}
                                                            >
                                                                {item.date}
                                                            </Typography>

                                                        </Box>
                                                    ))}
                                                </Box>
                                            </Grid>

                                            <Grid
                                                item
                                                xs={false}
                                                sm={true}
                                                md={true}
                                                sx={{ display: { xs: 'none', sm: 'block' } }}
                                            />
                                        </Grid>
                                    </Box>
                                )}

                                {isMobile && (
                                    <Box sx={{ fontFamily: 'Karla' }}>
                                        {/* Row 1: Title and Date Controls */}
                                        <Box sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            mb: 2,
                                            px: 1
                                        }}>
                                            <Typography
                                                variant="h5"
                                                sx={{
                                                    fontWeight: 600,
                                                    fontSize: '1.25rem'
                                                }}
                                            >
                                                Schedule
                                            </Typography>

                                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                                {/* Date Display */}
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        gap: 1,
                                                        px: 1.5,
                                                        py: 0.5,
                                                        marginLeft: '5px',
                                                        border: "1px solid #E0E0E0",
                                                        borderRadius: "8px",
                                                        backgroundColor: "#fff",
                                                    }}
                                                >
                                                    {/* Left arrow */}
                                                    <IconButton size="small" onClick={handlePrevDay}>
                                                        <KeyboardArrowLeft sx={{ fontSize: 18, color: "#4B5563" }} />
                                                    </IconButton>

                                                    {/* Date picker (mobile) */}
                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                        <MobileDatePicker
                                                            label={null}
                                                            format="MM/dd/yyyy"
                                                            value={data.date ? moment(data.date).toDate() : new Date()}
                                                            onChange={(e) => changeDate(e)}
                                                            slotProps={{
                                                                textField: {
                                                                    variant: "standard",
                                                                    InputProps: {
                                                                        disableUnderline: true,
                                                                        sx: {
                                                                            fontSize: { xs: "12px", sm: "14px" },
                                                                            color: "#374151",
                                                                            fontWeight: 500,
                                                                            textAlign: "center",
                                                                            cursor: "pointer",
                                                                            minWidth: "80px",
                                                                        },
                                                                    },
                                                                },
                                                            }}
                                                            sx={{
                                                                "& .MuiInputBase-root": {
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: 0.5,
                                                                },
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                    <IconButton size="small" onClick={handleNextDay}>
                                                        <KeyboardArrowRight sx={{ fontSize: 18, color: "#4B5563" }} />
                                                    </IconButton>
                                                </Box>

                                                <Button
                                                    onClick={getToday}
                                                    variant="outlined"
                                                    sx={{
                                                        backgroundColor: 'white',
                                                        color: '#000',
                                                        fontWeight: 500,
                                                        textTransform: 'none',
                                                        borderRadius: '8px',
                                                        borderColor: "#E0E0E0",
                                                        fontSize: '12px',
                                                        padding: '4px 12px',
                                                        minWidth: 'auto',
                                                        '&:hover': {
                                                            borderColor: '#BF1D2D',
                                                            backgroundColor: 'rgba(191, 29, 45, 0.04)'
                                                        }
                                                    }}
                                                >
                                                    Today
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Box>
                                )}

                                {pages && pages.includes('V3_Volunteer_Signup') &&
                                    <WeeklyVolunteerPositionAssign
                                        onExpandChange={handleExpandChange}
                                        open={expandAll}
                                        mode2={mode2}
                                        isNightShift={isNightShift}
                                        date={routeDate}
                                        allowedVars={allowedVars}
                                        shift={allShifts}
                                    />
                                }
                                <br />
                            </div>
                        </Paper>
                    </Grid>
                </Grid>
            )}
        </>
    );
}
